import { ProjectCode } from '@constants'
import { BrandCategory } from './brands'

export const STM_BRAND_CATEGORY: Partial<Record<ProjectCode, BrandCategory>> = {
  [ProjectCode.DCS]: BrandCategory.PET,
  [ProjectCode.LM]: BrandCategory.PET,
  [ProjectCode.HM]: BrandCategory.PET,
  [ProjectCode.MNP]: BrandCategory.PET,
  [ProjectCode.AQUA]: BrandCategory.PET,
  [ProjectCode.PP]: BrandCategory.PET,
  [ProjectCode.PM]: BrandCategory.PET,
  [ProjectCode.YT]: BrandCategory.HUMAN,
  [ProjectCode.RS]: BrandCategory.HUMAN,
}
